// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"langSelector__wrapper","item":"langSelector__item","active":"langSelector__active","checkbox-wrapper":"langSelector__checkbox-wrapper","label":"langSelector__label"};